import React from 'react'
import AceEditor from 'react-ace'

import 'ace-builds/src-noconflict/ext-emmet'
import 'ace-builds/src-noconflict/ext-language_tools'
import 'ace-builds/src-noconflict/ext-searchbox'
import 'ace-builds/src-noconflict/ext-static_highlight'
import 'ace-builds/src-noconflict/mode-html'
import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/snippets/html'
import 'ace-builds/src-noconflict/snippets/javascript'
import 'ace-builds/src-noconflict/theme-kuroir'

const style = {
  color: 'rgba(0, 0, 0, 0.3)',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
}

export interface Props {
  input: any
}

const AceTextEditor = ({ input }: Props) => {
  return (
    <div style={{ width: '100%' }}>
      <label className="ace-label" style={style}>
        本文
      </label>
      <AceEditor
        mode="html"
        theme="kuroir"
        value={input.value}
        onChange={(text) => input.onChange(text)}
        onFocus={(text) => input.onFocus(text)}
        editorProps={{ $blockScrolling: true }}
        width="100%"
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
          showLineNumbers: true,
          enableEmmet: true,
          tabSize: 2,
        }}
      />
    </div>
  )
}

export default AceTextEditor
